function init_adapex(){

    var ga = document.createElement('script'); 
    ga.type = 'text/javascript'; 
    ga.async = true;
    ga.src = 'https://cdn.adapex.io/hb/aaw.realclearpolitics.js';
    var s = document.getElementsByTagName('script')[0]; 
    s.parentNode.insertBefore(ga, s);
}

export default init_adapex;